import { render, staticRenderFns } from "./ExamMostCorrectQuestion.vue?vue&type=template&id=92250652&scoped=true"
import script from "./ExamMostCorrectQuestion.vue?vue&type=script&lang=js"
export * from "./ExamMostCorrectQuestion.vue?vue&type=script&lang=js"
import style0 from "./ExamMostCorrectQuestion.vue?vue&type=style&index=0&id=92250652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92250652",
  null
  
)

export default component.exports